export function validatePW(pw, originalPw = '') {
	if (!pw) {
		return '';
	}

	// 보안: 위험 문자(< > " ' ` \)나 공백이 있으면 비유효 (XSS/SQLi 완화)
	// eslint-disable-next-line
	if (/[<>"'`\\\s]/.test(pw)) {
		return 'non-valid';
	}

	if (pw.trim() === originalPw.trim()) {
		return 'non-valid';
	}

	// 영문 + 숫자 + 특수문자 각 1개 이상 필수, 8~20자.
	// 위험문자·공백은 위에서 이미 거부되므로, 영숫자가 아닌 나머지 = 허용 특수문자.
	const s = pw.trim();
	const hasAlpha = /[a-zA-Z]/.test(s);
	const hasNum = /[0-9]/.test(s);
	const hasSpecial = /[^a-zA-Z0-9]/.test(s);

	if (s.length >= 8 && s.length <= 20 && hasAlpha && hasNum && hasSpecial) {
		return 'valid';
	}

	return 'non-valid';
}

export function validateConfirmPW(pw, otherpw) {
	if (pw && otherpw) {
		if (pw === otherpw) {
			return 'valid';
		}

		return 'non-valid';
	}

	return '';
}
